/* eslint-disable */
require.config({
  shim: {
    'js/angularjs/1.5.8/angular': {
      exports: 'angular'
    },
    'js/angularjs/1.5.8/angular-couch-potato': {
      deps: ['js/angularjs/1.5.8/angular']
    },
    'js/angularjs/1.5.8/angular-ui-router': {
      deps: ['js/angularjs/1.5.8/angular']
    },
    'js/angularjs/1.5.8/angular-cookies': {
      deps: ['js/angularjs/1.5.8/angular']
    },
    'js/angularjs/1.5.8/angular-gettext': {
      deps: ['js/angularjs/1.5.8/angular']
    },
    'js/angularjs/1.5.8/ngDialog': {
      deps: ['js/angularjs/1.5.8/angular']
    }
  }
});
/* eslint-enable */
define([/* eslint-disable */
  'js/angularjs/1.5.8/angular',
  'js/angularjs/1.5.8/angular-couch-potato',
  'js/angularjs/1.5.8/angular-ui-router',
  'js/angularjs/1.5.8/angular-cookies',
  'js/angularjs/1.5.8/angular-gettext',
  'js/angularjs/1.5.8/angular-aria',
  'js/angularjs/1.5.8/angular-animate',
  'js/angularjs/1.5.8/ngDialog',
  /* eslint-enable */
], function(angular, couchPotato) {
  'use strict';

  var app = angular.module('app', [
    'scs.couch-potato',
    'ui.router',
    'ngCookies',
    'gettext',
    'ngDialog',
    'ngAria',
    'ngAnimate'
  ]);

  couchPotato.configureApp(app);

  return app;
});
